export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5020.88bb3f57.jpg";